import {Avatar} from 'shells/avatar/avatar';
import {Button} from 'shells/button/button';
import {Stack} from 'shells/layout/stack/stack';
import {StyledPopover} from 'shells/popover/styled-popover';
import {Body} from 'shells/typography/body';

import type {CreatorUserFragment} from 'nutshell-graphql-types';

import {CreateInfoPopoverEntityLink} from './create-info-popover-entity-link';

interface Props {
    creatorUser: CreatorUserFragment;
    onClose: () => void;
    anchor: HTMLElement | null | undefined;
}

export function CreateInfoPopover(props: Props) {
    return (
        <StyledPopover
            anchor={props.anchor}
            location='bottom'
            onBlur={props.onClose}
            disableFocusTrapZone={true}
        >
            <Stack spacing={16}>
                <Stack isHorizontal={true} spacing={8} alignItems='center'>
                    <Avatar
                        avatarUrl={props.creatorUser.avatarUrl}
                        initials={props.creatorUser.initials}
                        size={40}
                        type='users'
                    />
                    <Stack spacing={0}>
                        <Body size='large' color='dark' isBold={true}>
                            {props.creatorUser.name}
                        </Body>
                        <Body color='light' size='small'>
                            {props.creatorUser.primaryEmailAddress}
                        </Body>
                    </Stack>
                </Stack>
                <Stack spacing={24} isHorizontal={true}>
                    <Stack spacing={4}>
                        <Body size='small' color='dark' isBold={true}>
                            Assigned to {props.creatorUser.firstName}
                        </Body>
                        <CreateInfoPopoverEntityLink
                            entityType='accounts'
                            userId={props.creatorUser.id}
                        />
                        <CreateInfoPopoverEntityLink
                            entityType='contacts'
                            userId={props.creatorUser.id}
                        />
                        <CreateInfoPopoverEntityLink
                            entityType='leads'
                            userId={props.creatorUser.id}
                        />
                    </Stack>
                    {props.creatorUser.teams.length > 0 && (
                        <Stack spacing={4}>
                            <Body size='small' color='dark' isBold={true}>
                                {props.creatorUser.firstName}’s Teams
                            </Body>
                            {props.creatorUser.teams.map((team) => (
                                <Body key={team.id} size='small'>
                                    {team.name}
                                </Body>
                            ))}
                        </Stack>
                    )}
                </Stack>
                <div className='flex justify-end'>
                    <Button variant='secondary' size='small' onClick={props.onClose}>
                        Close
                    </Button>
                </div>
            </Stack>
        </StyledPopover>
    );
}
